import Notifications              from 'scripts/defa/notifications/collection-notifications';
import NotificationsDeleteForm    from 'scripts/defa/notifications/view-notifications-delete-form';
import NotificationCollectionView from 'scripts/defa/notifications/view-notification-collection-view';
import { NotificationsMenuView }  from 'scripts/defa/notifications/view-notifications-menu-view';
import Container                  from 'scripts/poppet/container';
import template                   from './template-notifications-container.jst.html';

const channelNav = Bb.Radio.channel( 'nav' );

const selectors = {
	regionNotifications: '[data-region=notifications-container]',
	deleteAllButton    : '[data-click=delete-all]',
	notificationsInfo  : '[data-info=notifications-info]'
};

export const NotificationContainer = Container.extend( {
	template,
	navHandler: 'internal',
	
	regions: {
		container: selectors.regionNotifications
	},
	
	ui: {
		deleteAll: selectors.deleteAllButton,
		info     : selectors.notificationsInfo
	},
	
	events: {
		'click @ui.deleteAll' : 'deleteAllNotifications'
	},
	
	attachView: function () {
		this.ui.deleteAll.addClass('hidden');
		this.ui.info.addClass('hidden');
		
		this.trigger('update:header', this.options.view);
		switch ( this.options.view ) {
			case 'menu':
				this._showMenu();
				break;
			case 'recipients':
				this._showRecipientGroups();
				break;
			case 'all':
				this._showAllNotifications();
				break;
			case 'deleteAll':
				this._showDeleteForm();
				break;
			case '':
				break;
			
		}
	},
	
	_showDeleteForm: function () {
		let notificationsDeleteForm = new NotificationsDeleteForm({
			collection: this.model.get( 'readNotifications' ),
			model: this.model,
			closeLink : false
		});
		
		this.showChildView( 'container', notificationsDeleteForm );
	},
	
	_showMenu: function () {
		let notificationMenuView = new NotificationsMenuView( {
			model: this.model
		} );
		this.showChildView( 'container', notificationMenuView, false );
	},
	
	_showRecipientGroups: function () {
		channelNav.trigger('unit:recipients', [ this.options.unitId, ]);
	},

	_showAllNotifications: function () {
		let self = this;
		this.model.fetchReadNotifications({
			success: () => {
				let allNotifications = this.model.get( 'readNotifications' );
				let view = new NotificationCollectionView({
					collection: new Notifications(allNotifications),
					emptyViewOptions: {context: 'allnotifications'},
				});
				
				self.showChildView('container', view);
				if ( allNotifications.length > 0 ) {
					self.ui.deleteAll.removeClass('hidden');
					self.ui.info.removeClass('hidden');
					
				}
			}
		});
	},


	/**
	 * Triggers when the DeleteAllNotifications button is clicked
	 * @void
	 * Deletes all Notification models.
	 * !TODO: Improve the delete confirmation method and add translation
	 * TODO: Let confirm-boxes have a title (needed for native apps)
	 */
	deleteAllNotifications: function(){
		let view = this.getRegion('container').currentView;
		this.trigger('delete:all', view.collection);
	},

	/**
	 * Triggers when the collectionview Triggers read
	 * @void
	 */
	onChildviewRead: function( notification, read) {
		this.trigger('read', notification, read);
	},

	onChildviewDelete: function( notification ){
		this.trigger('delete', notification);
	},

	onChildviewIsEmpty: function() {
		if( _.isFunction(this.ui.deleteAll.hasClass) &&
			!this.ui.deleteAll.hasClass('hidden')) {
			this.ui.deleteAll.addClass('hidden');
		}
	},

	onChildviewIsNotEmpty: function() {
		if( _.isFunction( this.ui.deleteAll.hasClass ) &&
			this.ui.deleteAll.hasClass('hidden')) {
			this.ui.deleteAll.removeClass('hidden');
		}
	},
	
} );
export default NotificationContainer;
